import { scriptLoad } from "@/wab/client/dom-utils";
import { withTimeout } from "@/wab/shared/common";
import { DEVFLAGS } from "@/wab/shared/devflags";

interface Recaptcha {
  ready(cb: () => void): void;
  execute(siteKey: string, opts: { action: string }): Promise<string>;
}

let recaptcha: Recaptcha | undefined;

async function loadRecaptcha(siteKey: string): Promise<Recaptcha | undefined> {
  recaptcha = (window as any).grecaptcha?.enterprise as Recaptcha;
  if (!recaptcha) {
    await scriptLoad(
      window,
      `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(
        siteKey
      )}`
    );
  }

  recaptcha = (window as any).grecaptcha?.enterprise as Recaptcha;
  if (!recaptcha) {
    return undefined;
  }

  return recaptcha;
}

export async function getRecaptchaToken({
  action,
}: {
  action: string;
}): Promise<string | undefined> {
  const siteKey = DEVFLAGS.recaptchaSiteKey;
  if (!siteKey) {
    return undefined;
  }

  try {
    return await withTimeout(
      (async () => {
        const recaptcha = await loadRecaptcha(siteKey);
        if (!recaptcha) {
          return undefined;
        }

        await new Promise<void>((resolve) => {
          recaptcha.ready(resolve);
        });

        return recaptcha.execute(siteKey, { action });
      })(),
      "getCaptchaToken timeout",
      10_000
    );
  } catch {
    // The client's getCaptchaToken must never throw or get stuck in case
    // reCAPTCHA servers go down, so we can quickly recover by pausing
    // enforcement on our server.
    return undefined;
  }
}
